<template>
	<div class="msg-list">
		<p :class="{more: true, disabled: moreBtnNoData}">
			<a class="icon icon-shijian" @click="getMoreMsg">查看更多消息</a>
			<span>已无更多消息</span>
		</p>
		<ul class="list" :style="listFont">
			<p v-if="!conversationList || !currentSessionId || !conversationList.find(o => o.id == currentSessionId) || !conversationList.find(o => o.id == currentSessionId).data || !conversationList.find(o => o.id == currentSessionId).data.length" class="shift">没有会话内容</p>
			<template v-else>
				<template v-for="msgObj in conversationList.find(o => o.id == currentSessionId).data">
					<li class="revoke-msg" v-if="msgObj.revoke">
						<span>你撤回了一条消息</span>
					</li>
					<li v-else :data-msgid="msgObj.id" :class="{client: !msgObj.isCustomer, fail: msgObj.sendStatus == 0, sending: msgObj.sendStatus == -1, 'is-ai-msg': msgObj.aiReply > 0, 'js-a-msg-cont': true}">
						<div class="msg-li-head">
							<span class="user-name">
								<template v-if="msgObj.aiReply > 0">AI</template>
								<template v-else>{{ msgObj.senderNickName }}</template>
							</span>

							<span class="date">{{ msgObj.msgDateCreatedStr }}</span>
							
							<span class="send-fail" v-if="msgObj.sendStatus == 0">[<i class="icon icon-fasongshibai"></i>发送失败]</span>
						</div>
						<div class="msg-box" :style="msgFont">
							<div v-if="msgObj.msgtype == 5" class="msg-box-text" v-html="msgHtmlToCard(msgObj.msgContent)"></div>
							<div v-else-if="msgObj.msgtype == 4" class="msg-box-text">
								<span class="voice-msg js-im-play-voice"></span>
								<audio class="none" controls :src="msgObj.msgFileUrl" preload="none" />
							</div>
							<div v-else-if="msgObj.msgtype == 3" class="msg-box-text">
								<video style="max-width: 60%;" controls :src="msgObj.msgFileUrl">
									暂不支持该视频格式 <a :href="msgObj.msgFileUrl" target="_blank">文件地址</a>
								</video>
							</div>
							<div v-else class="msg-box-text" v-html="msgHtmlToDialogue(msgObj.msgContent)" @click="getAiAnswer(msgObj)"></div>
							<div class="ai-aside-box" v-if="msgObj.aiReply > 0">
								<div class="ai-handle-box">
									<a class="js-ai-answer-error answer-error" href="javascript:;">错误</a>
									<a class="js-ai-answer-optimization answer-optimization" href="javascript:;">优化</a>
								</div>
							</div>
						</div>
						<div v-if="msgObj.segmentation" class="history-sign"><span>以上为历史消息</span></div>
					</li>
				</template>
			</template>
		</ul>
		<div class="js-key-frame-menu">
			<div v-if="currentShop.serviceType == '200067'" @click="revokeMsg">撤回消息</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'msgList',
	data () {
		return {
			moreBtnNoData: false, // 已无更多消息
			msgPage: 1, // 当前是第几页消息
			scrollToBottom: true, // 允许滚动到底部
			setImKey: 'SETIM',
			listFont: {},
			msgFont: {},
			conversationMsgList: []
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		},
		currentSessionId () {
			return this.$store.state.currentSessionId;
		},
		conversationList () {
			return this.$store.state.conversationList;
		},
		msgLoadStatus () {
			return this.$store.state.msgLoadStatus;
		},
		setImObj () {
			return this.$store.state.setImObj;
		}
	},
	mounted () {
		window._msgListSelf = this
		let self = this
		document.getElementsByClassName("msg-list")[0].addEventListener('scroll', this.scrollGetMoreMsg);
		$(document).on('click', '.msg-list-container .msg-list .list img', function() {
			// TJ_IM.zoomImImg($(this));
			let src = $(this).attr('src')
			self.$viewerApi({
				images: [src],
			})
		}).on('click', '.js-im-play-voice', function() {
			TJ_IM.playAudio($(this));
		});

		this.setFontSize();
	},
	watch: {
		conversationList: {
			deep: true,
			immediate: true,
			handler (val) {
				this.conversationMsgList = ((val || []).find(o => o.id == this.currentSessionId) || {}).data || []
			}
		},
		currentSessionId(now, old) {
			console.log('#10001', now, old)
			if (now == old) return;
			now ? this.getMsgList(now) : this.$store.commit('changeMsgLoadStatus', false);
		},
		conversationMsgList() {
			this.scrollToBottom ? this.setScrollToBottom() : (this.scrollToBottom = true);
		},
		msgLoadStatus () {
			var self = this;
			let msgList = ((this.conversationList || []).find(o => o.id == this.currentSessionId) || {}).data || []
			if (!self.msgLoadStatus && msgList.length) {
				self.getAiAnswer(msgList[msgList.length - 1]);
			}
		},
		setImObj: {
			deep: true,
			handler () {
				var self = this;
				self.setFontSize();
			}
		}
	},
    created() {
      document.addEventListener('contextmenu', this.contextmenuFun);
      document.addEventListener('mousedown', this.mousedownFun);
    },
    beforeDestroy() {
      this.interval && clearInterval(this.interval);
      document.removeEventListener('contextmenu', this.contextmenuFun);
      document.removeEventListener('mousedown', this.mousedownFun);
    },
	methods: {
		// 鼠标按下
		mousedownFun (e) {
			let $menu = document.querySelector('.js-key-frame-menu');
			if (!$(e.target).closest('.js-key-frame-menu').length) $menu.style.display = 'none';
			if ($(e.target).closest('.title').length && $(e.target).closest('.card-container').length) {
				this.copyText($(e.target).text()).then(() => {
					this.$message.success('复制成功')
				})
			}
		},

		// 鼠标菜单
		contextmenuFun (e) {
			let _event = window.event || e; //事件对象
			let x = _event.clientX; // 鼠标的x坐标
			let y = _event.clientY; //鼠标的y坐标
			let $msg = $(e.target).closest('.js-a-msg-cont');

			if (!$msg.length || $msg.hasClass('client') || $msg.hasClass('client') || $msg.hasClass('fail') || $msg.hasClass('sending') || $msg.hasClass('is-ai-msg')) return;

			let $menu = document.querySelector('.js-key-frame-menu');
			$menu.style.left = x + "px";
			$menu.style.top = y  + "px";
			$menu.style.display = 'block';
			$menu.setAttribute('data-id', $msg.data('msgid'));

			_event.stopPropagation();
			//阻止默认行为
			if(_event.preventDefault){
				_event.preventDefault(); //标准格式
			}else{
				_event.returnValue = false; //IE格式
			}
		},

		copyText(text) {
			return new Promise((resolve, reject) => {
				const input = document.createElement('textarea')
				document.body.appendChild(input)
				input.value = text
				input.style.position = 'absolute'
				input.style.opacity = 0
				input.style.top = 0
				input.select()
				input.setSelectionRange(0, text.length)
				if (document.execCommand('copy')) {
					document.execCommand('copy')
					// this.$message.success('复制成功')
					resolve()
				} else {
					// this.$message.error('操作失败，请手动复制')
					reject()
				}
				document.body.removeChild(input)
			})
		},

		// 撤回消息
		revokeMsg () {
			let self = this;
			let data = {
				messageId: document.querySelector('.js-key-frame-menu').getAttribute('data-id')
			};

			self.$axios.post(API_ROOT.url + '/MessageApi.recallMsg', data).then(result => {
				if (result.status) {
					$('.js-key-frame-menu').hide();
					TJ_DB.get(TJ_DB.M_Table, "'sessionid' == '" + self.currentSessionId + "'", function(result) {
						if (result.length) {
							var key = null;
							for (var i = 0; i < result.length; i++) {
								if (result[i].id == data.messageId*1) {
									key = result[i].createKey;
									break;
								}
							}
							if (key) {
								TJ_DB.edit(TJ_DB.M_Table, key, {revoke: 1}, function() {
									self.getMsgList(self.currentSessionId);
								});
							} else {
								$('.js-a-msg-cont[data-msgid="' + data.messageId + '"]').remove();
							}
						} else {
							$('.js-a-msg-cont[data-msgid="' + data.messageId + '"]').remove();
						}
					});
				} else {
					self.$alert('撤回消息失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('撤回消息失败，失败原因：网络繁忙');
			})
		},

		// 设置字体大小
		setFontSize () {
			var self = this,
				setJson = localStorage.getItem(self.setImKey) ? JSON.parse(localStorage.getItem(self.setImKey)) : {};

			if (!setJson.fontSize) return;
			self.listFont = {
				'font-size': setJson.fontSize + 'px'
			};
			self.msgFont = {
				'font-size': (setJson.fontSize + 1) + 'px'
			};
		},

		// 重置参数
		reSetData () {
			var self = this;
			self.moreBtnNoData = false;
			self.msgPage = 1;
		},

		// 时间戳格式化
		formatTime (time, format) {
			return new Date(time).format(format);
		},

		// 把html转换为对话信息
		msgHtmlToDialogue (html) {
			return TJ_IM.msgHtmlToDialogue(html, this.currentShop.serviceType);
		},

		// 消息转卡片
		msgHtmlToCard(jsonStr) {
			try {
				var obj = JSON.parse(jsonStr);
				return '<div class="card-container">\
							<div class="content-container">\
								<div class="img-box"><a ' + (obj.card_link ? 'target="_blank"' : '') + ' href="' + (obj.card_link || 'javascript:;') + '" style="background-image: url(' + (obj.card_img || '') + ')"></a></div>\
								<div class="content-box">\
									<h3 class="title"><a ' + (obj.card_link ? 'target="_blank"' : '') + ' href="' + (obj.card_link || 'javascript:;') + '">' + (obj.card_title || '??') + '</a></h3>\
									<div class="info">' + (obj.card_info || '') + '</div>\
								</div>\
							</div>\
						</div>';
			} catch(e) {
				return jsonStr
			}
		},

		// 更新聊天框数据后滚动到最底部
		setScrollToBottom () {
			var self = this,
				sessionId = self.currentSessionId;

			self.$nextTick(() => {
				var $msgList = document.getElementsByClassName("msg-list")[0];

				$msgList.scrollTop = $msgList.scrollHeight;
				$('.msg-list .list').find('img').load(function(){
					if (self.currentSessionId != sessionId) return;
					$msgList.scrollTop = $msgList.scrollHeight;
				}).error(function(){
					if (self.currentSessionId != sessionId) return;
					$msgList.scrollTop = $msgList.scrollHeight;
				});
			});
		},

		// 滚动获取更多聊天记录
		scrollGetMoreMsg () {
			var self = this;
			if (document.getElementsByClassName("msg-list")[0].scrollTop > 5) return;
			self.getMoreMsg();
		},

		// 获取当前会话的聊天数据
		getMsgList (sessionId) {
			var self = this;

			self.reSetData();
			self.$store.commit('changeMsgLoadStatus', true);
			let conversationObj = self.conversationList.find(o => o.id === sessionId) || {}
			if (!conversationObj.closed) {
				TJ_DB.get(TJ_DB.M_Table, "'sessionid' == '" + sessionId + "'", (result) => {
					if (result.length) {
						let tempArr = JSON.parse(JSON.stringify(self.conversationList)).map(o => {
							if (o.id === sessionId) {
								o.data = result
							}
							return o
						})
						console.log('#10002', tempArr)
						self.$store.commit('changeConversationList', tempArr);
						self.$store.commit('changeMsgLoadStatus', false);
						if (result.length < 10) {
							self.getMoreMsg();
						}
					} else {
						getDataFromServer();
					}
				});
			} else {
				getDataFromServer ();
			}

			function getDataFromServer () {
				var data = {
					serviceType: self.currentShop.serviceType,
					sessionId: sessionId
				};
				self.$axios.post(API_ROOT.url + '/MessageApi.getMsgList', data).then(result => {
					if (result.status) {
						// 未关闭的会话获取消息列表时需要把该消息存起来
						if (!conversationObj.closed) TJ_DB.add(TJ_DB.M_Table, result.data);

						if (result.data.length) {
							let tempArr = self.conversationList.map(o => {
								if (o.id === sessionId) {
									o.data = result.data
								}
								return o
							})
							self.$store.commit('changeConversationList', tempArr);
						} else {
							var moreData = {
								serviceType: self.currentShop.serviceType,
								clientId: conversationObj.clientid,
								lastDate: (new Date()).format('yyyy-MM-dd hh:mm:ss'),
								exceptId: null,
								sessionId: ''
							};
							self.$axios.post(API_ROOT.url + '/MessageApi.moreMsgListNew', moreData).then(moreRes => {
								if (moreRes.status) {
									if (moreRes.data.length) {
										moreRes.data[moreRes.data.length - 1].segmentation = true;
									}
								}
								let tempArr = self.conversationList.map(o => {
									if (o.id === sessionId) {
										o.data = moreRes.data
									}
									return o
								})
								self.$store.commit('changeConversationList', tempArr);
							})
						}
					} else {
						self.$alert('获取聊天数据错误，错误原因：' + result.msg);
					}
					self.$store.commit('changeMsgLoadStatus', false);
				}, response => {
					self.$alert('获取聊天数据错误，错误码(' + response + ')');
					self.$store.commit('changeMsgLoadStatus', false);
				})
			}
		},
			
		// 获取更多聊天记录
		getMoreMsg () {
			let msgList = ((this.conversationList || []).find(o => o.id == this.currentSessionId) || {}).data || []
			let coypMsgList = JSON.parse(JSON.stringify(msgList))
			var self = this,
				sessionId = self.currentSessionId,
				lastDate = msgList.length ? msgList[0].msgDateCreatedStr : null,
				exceptId = msgList.length ? msgList[0].uuid : null,
				conversationObj = self.conversationList.find(o => o.id == self.currentSessionId) || {},
				data = {
					serviceType: self.currentShop.serviceType,
					clientId: conversationObj.clientid,
					lastDate: lastDate,
					exceptId: exceptId,
					sessionId: sessionId
				};
			
			if(!msgList.length || self.$store.state.msgLoadStatus || self.moreBtnNoData || !lastDate) return;
			self.$store.commit('changeMsgLoadStatus', true);
			var sendTime = +new Date();

			self.$axios.post(API_ROOT.url + '/MessageApi.moreMsgListNew', data).then(result => {
				var setTimeOut = setLeastWaitTime();
				setTimeout(function(){
					if (conversationObj.clientid != data.clientId) return;
					if (!result.status) {
						self.$store.commit('changeMsgLoadStatus', false);
						self.$alert('获取更多聊天记录时出错，错误原因：' + result.msg);
						return;
					}
					if (result.data.length) {
						var oldSH = document.getElementsByClassName("msg-list")[0].scrollHeight,
							oldST = document.getElementsByClassName("msg-list")[0].scrollTop;

						if (!coypMsgList.find(o => o.segmentation)) {
							result.data[result.data.length - 1].segmentation = true;
						}

						let tempArr = self.conversationList.map(o => {
							if (o.id === sessionId) {
								o.data = [...result.data, ...coypMsgList]
							}
							return o
						})
						self.$store.commit('changeConversationList', tempArr);
						self.scrollToBottom = false;
						self.msgPage++;
						self.$nextTick(() => {
							self.setScrollToCurrent($('.msg-list'), oldSH, oldST, self.currentSessionId);
						});
					} else {
						self.$store.commit('changeMsgLoadStatus', false);
						self.moreBtnNoData = true;
					}
				}, setTimeOut);
			}, response => {
				var setTimeOut = setLeastWaitTime();
				setTimeout(function(){
					if (self.currentSessionId != data.sessionId) return;
					self.$alert('获取更多聊天记录时出错，错误码：(' + response + ')');
					self.$store.commit('changeMsgLoadStatus', false);
				}, setTimeOut);
			});

			// 设置至少等待时间(搞了个转圈的加载动画，这个动画至少都要显示半秒，哪怕在这之前获取到了数据，也要等半秒后再渲染)
			function setLeastWaitTime(){
				var getTime = +new Date(),
					time = sendTime + 500 - getTime;
				if(time < 0) time = 0;
				return time;
			}
		},

		// 加载更多聊天记录后，界面保持在当前查看的位置(每加载完一张图片就设置一次，如果等所有图片都加载完后再设置，会因等待时间长出现闪屏现象)
		setScrollToCurrent ($container, height, scrollTop, sessionId) {
			var self = this,
				$msgList = $container.find('.list');

			callback();
			$msgList.find('img').load(function(){
				callback();
			}).error(function(){
				callback();
			});
			self.$store.commit('changeMsgLoadStatus', false);

			function callback(){
				if (self.currentSessionId != sessionId) return;
				$container[0].scrollTop = $container[0].scrollHeight - height + scrollTop;
			}
		},

		// 点击消息，获取对应的AI答案
		getAiAnswer (msgObj) {
			var self = this,
				str = "AIANSWER-" + self.currentSessionId + '-' + msgObj.uuid;

			if (!sessionStorage.getItem(str)) { // 如果该条消息没获取过答案，直接返回
				self.$store.commit('changeShowAiAnswer', false);
				return;
			}

			var domain = JSON.parse(sessionStorage.getItem(str)),
				content = domain.msgContent.recommendAns ? domain.msgContent.recommendAns : [],
				ansArr = [];

			for (var i = 0; i < content.length && i < 2; i++) {
				var obj = JSON.parse(JSON.stringify(domain));
				obj.msgContent = content[i];
				ansArr.push(obj);
			}

			if (ansArr.length) {
				self.$store.commit('changeAiAuxiliaryAnswer', ansArr);
				self.$store.commit('changeShowAiAnswer', true);
			} else {
				self.$store.commit('changeShowAiAnswer', false);
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/msgList/msgList.vue